module.exports = __webpack_public_path__ + "static/media/handle.f9fffb77.jpeg";